<template>
  <div class="standing adminServiceIndex">
    <div class="lading_conter_search" id="lading_conter_search-billLading">
      <my-search-query :fromList="fromList" :height="heightSearch" @queryEven="getTableParams(false)" ref="queryList"/>
    </div>
    <div class="standing-bar">
      <search>
        <el-button type="primary" size="small" @click.native="operationInfoEven" icon="el-icon-tickets"> 详情</el-button>
        <!--<el-button type="primary" size="small" @click.native="operationAddEven" icon="el-hg-icon-add"> 新增</el-button>-->
        <el-dropdown >
          <el-button type="primary" size="small" icon="el-hg-icon-add"> 新增</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operationAddEven(li.ServiceID)" v-for="(li,i) in serviceIdList" :key="i" :v-permission="`12${li.ServiceID == '06' ? '21' : li.ServiceID}`">
              新增{{li.ServiceName}}提单
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="serviceIdList.length===1" v-permission="'1201'"
                   @click.native="operationAddEven(serviceIdList[0].ServiceID)"
                   type="primary" size="small" icon="el-hg-icon-add"> 新增
        </el-button>
        <el-button type="primary" size="small" @click.native="operationEditEven" v-permission="'1202'"
                   :disabled="disableBtnedit" icon="el-hg-icon-edit"> 修改
        </el-button>
        <el-button type="primary" size="small" @click.native="btnConfirm(riskCheck,'1','是否提交选中提单？')"
                   v-permission="'1205'"
                   :disabled="disableBtncommit" icon="el-hg-icon-audit"> 提交
        </el-button>
        <el-button type="primary" size="small" @click.native="btnConfirm(riskCheck,'2','是否撤回选中提单？')"
                   v-permission="'1206'"
                   :disabled="disableBtnRevoke"
                   icon="el-hg-icon-sumcancle"> 撤回
        </el-button>
        <el-button type="danger" size="small" @click.native="btnConfirm(riskCheck,'3','是否作废选中提单？')"
                   v-permission="'1203'"
                   icon="el-icon-remove"
                   :disabled="disableBtnDel"> 作废
        </el-button>
        <el-button type="primary" size="small" @click.native="getTableParams(false)" icon="el-icon-refresh"> 刷新
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-upload" @click="$refs.spTable.exportExcel()">导出</el-button>
      </search>
    </div>
    <div class="lading_conter">
      <div class="lading_table">
        <div class="lading_conter_table">
          <sp-table
            ref="spTable"
            :parentTableData.sync="tableData"
            :parentCol.sync="colList"
            :dragDrop=true
            :id-edit="false"
            @addNewData="addNewData"
            :summary-data="summaryData"
            :summary-method="getSummaries"
            show-summary
            @selection-change="handleSelectionChange"
            @getDetail="operationInfoEven"
            width="100%"
            @header-click="headerClickEven"
          >
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50" class-name="index"></el-table-column>
            <sp-table-column :align="item.titleAlignment" v-for="(item, index) in colList" :key="`col_${index}`"
                             :width="item.width"
                             :sortable="colList[index].sortableStart"
                             :sort-orders="['ascending','descending',null]"
                             :prop="colList[index].field"
            >
              <template slot="header">
                <p :class="item.field">{{item.title}}</p>
              </template>
              <template v-slot="{ scope }">
                <div :style="{ textAlign: item.alignment}" :class="[initColor(scope.row),'span']">
                  {{item.id ? item.id : item.uid}}
                  {{scope.row[colList[index].field]}}
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
        <div class="page">
          <page-modle
            :currentPage="currentPage"
            :total="total"
            :pageSize="pageSize"
            @currentChange="currentChange"
            @sizeChange="sizeChange"/>
        </div>
      </div>
    </div>
    <Dialog :title="'请输入手机号'+ Codephone+'收到的验证码'" :width="400"
            :height="100" :visible="msgCodeShow"
            @close="msgCodeShow = !msgCodeShow">
      <div class="grid-contain dialog edit">
        <el-form label-width="80px" style="margin-top: 10%">
          <el-form-item label="验证码" class="required">
            <el-input size="small" v-model="msgCode" placeholder="请输入六位验证码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-button size="small" icon="el-hg-icon-save" type="primary" @click="checkMsgCode"
                     style="margin-left: 20px">确定
          </el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
  import {spTable, spTableColumn} from '@/components/sptable';
  import pageModle from '@/views/comm/pagination';
  import mySearchQuery from '../comm/searchQuery';
  import Search from 'views/comm/search';
  import {mapGetters, mapActions} from 'vuex';
  import Dialog from '@/components/dialog';
  import dayjs from 'dayjs';
  import storageM from '@/storage';

  const storage = storageM['sessionStorage'];
  const _ = require('lodash');

  export default {
    name: 'adminBillLading',
    components: {
      spTable,
      spTableColumn,
      mySearchQuery,
      pageModle,
      Search,
      Dialog
    },
    data() {
      return {
        tableData: [],
        bargain: [],
        productNumList: [],
        getTGuestNumList: [],
        getBlno: [],
        getCreator: [],
        heightSearch: 0,
        currentPage: 1,
        pageSize: 10,
        total: 0,
        userChoice: [],
        addOperationStart: false,
        msgCodeShow: false,
        currF: '',
        currFpar: '',
        msgCode: '',
        colList: [],
        itmeState: {
          '0': '已创建',
          '1': '已操作完成',
          '90': '已有效',
          '91': '操作中',
          '100': '已完成',
          '99': '审核中',
          '-1': '已作废',
        },
        serviceIdList: [],
        billlist: [],
        disableBtnRevoke: true,
        disableBtnDel: true,
        disableBtnedit: true,
        disableBtncommit: true,
        summaryData: '',
        Codephone: '',
        serveIdAndRouteNameList:[{id:'08',info:'adminBillLadingUnload',add:'adminAddBillLadingUnload',name:'卸车'},
          {id:'09',info:'adminBillLadingLading',add:'adminAddBillLadingLading',name:'装车'},
          {id:'06',info:'adminBillLadingUnloadShip',add:'adminAddBillLadingUnloadShip',name:'卸船'},
          {id:'07',info:'adminBillLadingShip',add:'adminAddBillLadingShip',name:'装船'},
          {id:'14',info:'adminBillLadingPipe',add:'adminAddBillLadingPipe',name:'管线进'},
          {id:'15',info:'adminBillLadingUnloadPipe',add:'adminAddBillLadingUnloadPipe',name:'管线出'},
          {id:'20',info:'adminBillLadingTransfer',add:'adminAddBillLadingTransfer',name:'转罐'},
        ],
      };
    },
    updated() {
      let height = this.$refs.spTable.$el.clientHeight;
      this.heightSearch = height > 592 ? height : 592;
    },
    activated() {
      let start = storage.$get({key: 'adminServiceTable',});
      if (start) {
        storage.$remove({
          key: 'adminServiceTable',
        });
        this.getTableParams(false);
      }
    },
    async created() {
      await this.allQueryAPI();
      this.initCol();
    },
    async mounted() {
      // this.$refs.queryList.resizeSearch('billLading');
      // await this.allQueryAPI();
      // this.initCol();
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        adminMainOrder: 'dictionary/adminMainOrder',
        visitedViews: 'tags/visitedViews',
      }),
      fromList() {
        let arr = [
          {
            label: '产品',
            key: 'goodsId',
            type: 'select',
            showDialog: true,
            tips: '...',
            dialog: 'showGoodsID',
            valData: this.productNumList,
            code: 5002,
            labelVal: 'Name',
            value: 'GoodsID',
            multiple: false,
            colSpan: 8
          },
          {
            label: '提单号',
            key: 'blno',
            valData: this.getBlno,
            type: 'input',
            labelVal: 'BLNO',
            value: 'BLNO',
            colSpan: 8
          },
          {
            label: '合同号',
            key: 'bargainId',
            valData: this.bargain,
            type: 'select',
            tips: '...',
            dialog: 'showmainOrderGetTGuest',
            labelVal: 'BargainID',
            multiple: false,
            value: 'BargainID',
            code: 7000,
            colSpan: 8
          },
          {
            label: '类别',
            key: 'serviceId',
            type: 'select',
            valData: this.serviceIdList,
            labelVal: 'ServiceName',
            value: 'ServiceID',
            multiple: true,
            colSpan: 8
          },
          {
            label: '开始时间',
            key: 'beginDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByMonth(new Date(), 1)} 00:00:01`,
            colSpan: 8
          },
          {
            label: '结束时间',
            key: 'endDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`,
            colSpan: 8
          },
          {
            label: '车号',
            key: 'carNo',
            type: 'input',
            colSpan: 8
          },
          {
            label: '提货人',
            key: 'tGuestId',
            valData: this.getTGuestNumList,
            type: 'select',
            tips: '...',
            dialog: 'showgetTGuest2',
            labelVal: 'Name',
            value: 'GuestID',
            code: 4000,
            colSpan: 8
          },
          {
            label: '单据状态',
            key: 'state',
            type: 'checkbox',
            valData: this.billlist,
            labelVal: 'value',
            value: 'key',
            multiple: true,
            colSpan: 24
          },
        ];
        return arr;
      },
    },
    methods: {
      doOperate(t) {
        switch (t) {
          case '1':
            this.doAudit();
            break;
          case '2':
            this.operationRecallEven();
            break;
          case '3':
            this.operationDeleteEven();
            break;
          default:
            break;
        }
      },
      riskCheck(f, p) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getRiskCtrlLevel',
          params: {accountId: this.userInfor.accountId},
        }).then(res => {
          if (res.bean) {
            this.currF = f;
            this.currFpar = p;
            res.bean.riskCtrlLevel == 2 ? this.sendCode() : this.doOperate(f);
          }
        });
      },
      sendCode() {
        if (this.userInfor.phone) {
          this.$services.postLoading({
            type: 'WECHAT',
            url: 'sendSMSCode',
            params: {phoneNumber: this.userInfor.phone},
          }).then(res => {
            if (res.code === '000') {
              this.Codephone = this.userInfor.phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
              this.msgCodeShow = true;
            }
          });
        }
        else {
          this.$message({
            message: '未维护手机号，不允许下单。请与客服人员联系后重试！',
            type: 'error',
          });
        }
      },
      checkMsgCode() {

        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'checkRefPhone',
          params: {phoneNumber: this.userInfor.phone, SMSCode: this.msgCode},
        }).then(res => {
          if (res.code === '000') {
            this.msgCodeShow = !this.msgCodeShow;
            this.$message({
              message: '校验成功，执行保存',
              type: 'success',
            });
            // this.checkForm();
            this.doOperate(this.currF);
          }
          else {
            this.$message({
              message: '校验失败，请重新输入',
              type: 'error',
            });
          }
        });
      },
      btnConfirm(F, t, str) {
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof F === "function") F(t);

        });
      },
      getSummaries(param) {
        const countList = ['BLNumber', "RealNumber", "LeftNumber"];
        const countObj = {
          BLNumber: {
            unit: ' ',
          }, RealNumber: {
            unit: ' ',
          }, LeftNumber: {
            unit: ' ',
          },
        };
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (countObj[column.property]) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                }
                return prev;
              }, 0);
              sums[index] = sums[index].toFixed(3);
              sums[index] += countObj[column.property].unit;
            }
            else {
              sums[index] = '';
            }
          }
        });
        this.summaryData = [countList, sums];
        return sums;
      },
      headerClickEven(column, event) {
        this.colList.forEach((itme, key) => {
          if (column.property === itme.field) {
            !itme.sortableStart ? column.order = 'ascending' : '';
            itme.sortableStart = true;
            if (column.order === null) {
              itme.sortableStart = false;
              column.order = '';
            }
            this.$forceUpdate();
          }
        });
      },
      // 获取单据状态
      getStateList() {
        return new Promise((resolve, rej) => {
          this.$services.post({
            type: 'GUESTBUSINESS',
            url: 'getStateList',
            params: {
              accountId: this.userInfor.accountId,
            },
          }).then(res => {
            this.billlist = res.bean;
            resolve();
          });
        });

      },
      // 获取服务编号
      getServiceIdAPI() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getServiceForWeb',
          params: {
            AccountID : this.userInfor.accountId,
            orderType:'0,1,2,3,9,10,11'
          },
        }).then(res => {
          this.serviceIdList = res.bean;
          if (this.serviceIdList.length > 1) {
            this.getTableParams(false);
          }
        });
      },
      initColor(item) {
        const State = {
          10: 'orderState_color10',
          2: 'orderState_color2',
          0: 'orderState_color3',
          '-1': 'orderState_color4',
          99: 'orderState_color5',
          90: 'orderState_color6',
          91: 'orderState_color7',
          100: 'orderState_color1',
        };
        if (item.IsRed === 1) {
          return 'orderState_color8';
        }
        if (State[item.State]) return State[item.State];
        return 'orderState_color9';
      },
      addNewData(callback) {
        this.tableData.push(JSON.parse(JSON.stringify(
          Object.assign({
            uid: this.$utils.getUid(),
          }, this.originData),
        )));
        this.$nextTick(() => {
          callback();
        });
      },
      // 导出事件
      exportEven() {

      },
      // 条件事件集合
      async allQueryAPI() {
        await this.getBargainEven();
        await this.getServiceIdAPI();
        await this.productNum();
        await this.getTGuestNum();
        await this.getStateList();
        await this.getTableParams(false);
      },
      // 合同号弹出选择
      getBargainEven() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getBargain',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.bargain = res.bean;
        });
      },
      // 制表人接口
      getCreatorEven() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getCreator',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getCreator = res.bean;
        });
      },
      // page翻页回调
      currentChange(val) {
        this.currentPage = val;
        this.getTableParams(false);
      },
      // 每页显示数据内容变化
      sizeChange(val) {
        this.pageSize = val;
        this.getTableParams(false);
      },
      // 产品编号
      productNum() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getGoods',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.productNumList = res.bean;
        });
      },
      // 提货人编号
      getTGuestNum() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getRefTGuest',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.getTGuestNumList = res.bean;
        });
      },
      // 获取台帐table数据
      getTableList(params) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'mainOrderList',
          params,
        }).then(res => {
          this.tableData = res.bean.map(item => {
            item.uid = this.$utils.getUid();
            item.OrderType = item.OrderType === 3 ? '装汽车' : '卸汽车';
            if (item.IsNon) {
              item.IsNon = item.IsNon === true ? '需要' : '不需要';
            }
            // item.State = this.itmeState[String(item.State)];
            return item;
          });
          if (this.tableData[0]) {
            this.total = this.tableData[0].OWTableCounts;
          }
          else {
            this.total = 0;
            this.currentPage = 1;
          }
          this.$refs.spTable.initTable();
        });
      },
      // 台帐参数处理
      getTableParams(start) {
        let params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          accountId: this.userInfor.accountId,
          dateTimeType: 'createDate',
          beginDate: '2019-01-01 00:00:00',
          endDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        };
        if (!start) {
          let fromData = _.cloneDeep(this.$refs.queryList.fromData);
          if (fromData.serviceId) {
            params.serviceId = fromData.serviceId.join(',');
          }
          else {
            delete fromData.serviceId;
          }
          if (fromData.state[0]) {
            params.state = fromData.state.join(',');
          }
          if (fromData.beginDate) {
            params.beginDate = fromData.beginDate;
            delete fromData.beginDate;
          }
          // if (!fromData.goodsName) fromData.goodsId = '';
          for (let i in fromData) {
            if (!fromData[i] || typeof fromData[i] === 'object') {
              delete fromData[i];
            }
          }
          Object.assign(params, fromData);
        }
        this.getTableList(params);
      },
      // 用户勾选数据
      handleSelectionChange(val) {
        this.userChoice = val;
        if (val.length === 0) {
          this.disableBtnDel = true
          this.disableBtnRevoke = true
          this.disableBtnedit = true
          this.disableBtncommit = true
          return
        } 
        let RevokeRE = true, DelRE = true, editRE = true, commitRE = true;
        val.forEach(v => {
          if (v.State !== 2 || v.WebType === 1) {
            this.disableBtnRevoke = true;
            RevokeRE = false;
          }
          if (v.State !== 0 || v.WebType === 1) {
            this.disableBtnDel = true;
            DelRE = false;
          }
          if (v.State !== 0 || v.WebType === 1) {
            this.disableBtnedit = true;
            editRE = false;
            this.disableBtncommit = true;
            commitRE = false;
          }
        });

        RevokeRE ? this.disableBtnRevoke = false : '';
        DelRE ? this.disableBtnDel = false : '';
        editRE ? this.disableBtnedit = false : '';
        commitRE ? this.disableBtncommit = false : '';
      },
      // 详情
      operationInfoEven() {
        if (this.userChoice.length > 1 || this.userChoice.length === 0) {
          this.$message({
            type: 'warning',
            message: '请选择一条数据查看',
          });
          return false;
        }
        this.serveIdAndRouteNameList.forEach((v)=>{
          if(v.name===this.userChoice[0].OrderTypeName){
            this.goToJumpDetail(v.info, 'info');
          }
        });
      },
      goToJumpDetail(rn, type){
        this.titleChange(rn);
        storage.$set({
          key: 'adminServiceTableDetail',
          parameter: true,
        });
        this.$router.push({
          name: rn,
          query: {
            id: this.userChoice[0].BillID,
            type: type,
            WebType: this.userChoice[0].WebType,
            MainOrder: this.userChoice[0].MainOrderID
          }
        });
      },
      titleChange(path) {
        this.visitedViews.forEach(v => {
          v.name.indexOf(path) > -1 && v.title.indexOf('新增') > -1 ? v.title = v.title.replace(/新增/, '') + '详情' : '';
        });
      },
      // 添加
      operationAddEven(type) {
        this.$services.postLoading({
          type: 'ERP',
          url: 'getBillId',
          params: {
            tableId: 'W_MainOrder',
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          let bean = JSON.parse(res.bean);
          let BillID = bean[0].BillID;
          let FieldValue = bean[0].FieldValue;
          this.serveIdAndRouteNameList.forEach((v)=>{
            if(v.id===type){
              this.goToJump(v.add,BillID,FieldValue);
            }
          });
        });
      },
      goToJump(routeName,BillID,FieldValue){
        this.$router.push({
          name: routeName,
          query: {id: BillID, type: 'add', MainOrder: FieldValue, WebType: 0,},
        });
      },
      // 编辑
      operationEditEven() {
        if (this.userChoice.length > 1 || this.userChoice.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择一条数据修改',
          });
          return false;
        }
        this.serveIdAndRouteNameList.forEach((v)=>{
          if(v.name===this.userChoice[0].OrderTypeName){
            this.goToJumpDetail(v.info, 'edit');
          }
        });
      },
      //撤回
      operationRecallEven() {
        this.userChoice.forEach(itme => {
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'orderRevoke',
            params: {
              billId: itme.BillID,
              accountId: this.userInfor.accountId,
            },
          }).then(res => {
            if (typeof res.bean === 'string') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
            }
            else if (res.bean[0].RetCode == 100) {
              this.$message({
                message: '撤回成功！',
                type: 'success',
              });
              this.getTableParams(false);
              storage.$set({
                key: 'adminServiceTableDetail',
                parameter: true,
              });      
            }
          });
        });
      },
      // 提交
      doAudit() {
        this.userChoice.forEach(itme => {
          this.$services.post({
            type: 'GUESTBUSINESS',
            url: 'orderInsertToERP',
            params: {
              accountId: this.userInfor.accountId,
              billId: itme.BillID,
              type: 0
            },
          }).then(res => {
            if (res.bean || res.code === '000') {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              storage.$set({
                key: 'adminServiceTableDetail',
                parameter: true,
              }); 
            }
            this.getTableParams(false);          
          });
        });

      },
      // 作废
      operationDeleteEven() {
        this.userChoice.forEach(itme => {
          this.$services.postLoading({
            type: 'ERP',
            url: 'doBlankOut',
            params: {
              aAccountId: this.userInfor.accountId,
              aTableId: 'W_MainOrder',
              aBillId: itme.BillID,
              aAuditStep: '',
              pFuncId: 625,
              aOperatorId: this.userInfor.id,
              pAccountId: '',
              pProId: 100022,
            },
          }).then(res => {
            if (res.code === '000') {
              this.$message({
                message: '作废成功！',
                type: 'success',
              })
              storage.$set({
                key: 'adminServiceTableDetail',
                parameter: true,
              });
            }
            if (typeof res.bean === 'string') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
            }
            this.getTableParams(false);
          });
        });
      },
      initCol() {
        this.adminMainOrder.length > 0
        && (this.colList = this.adminMainOrder.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.sortableStart = false;
            return info;
          })
        );
      },
    },
    watch: {
      adminMainOrder() {
        this.initCol();
      },
      colList(val) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
  };
</script>
<style lang="scss">
  .standing {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .lading_conter_table{
    max-height: 83%;
  }

  .adminServiceIndex {
    .el-table__body-wrapper {
      height: calc(100% - 53px);
    }
  }
</style>
